import { Component, OnInit, ViewChild, Directive, Input, OnChanges } from '@angular/core';
import { ExclusionVehiculosService } from "./solicitud-vehiculos.service";
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { PolizaEntity } from "../entities/polizas_cliente_entity";
import { VehiculosExclusionEntity, CabeceraVehiculosExclusionEntity } from "../entities/vehiculos_exclusion_entity";
import { EspecificacionVehiculoEntity } from "../../../components/common/utils/entities/especificacionesVehiculo";
import { UtilService } from "../../../components/common/utils/util.service";
import { ExtrasEntity, DetalleVehiculoEntity } from "../../masivos/datosGenerales/entities/detalle_vehiculo_entity";
import { FileUploader } from "ng2-file-upload";
import { Observable } from "rxjs/Rx";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { OtrosExclusionEntity, DatosFacturaEntity, DatosInspeccionEntity } from '../entities/otros_exclusion_entity';
import { CalendarFechaNac } from '../../../components/common/utils/calendarFechaNacParametros';

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'exclusionVehiculos',
    providers: [],
    templateUrl: 'solicitud-vehiculos.template.html',
    styleUrls: ["solicitud-vehiculos.style.css"]

})

export class ExclusionVehiculos extends CalendarFechaNac implements OnChanges {
    vehiculos: VehiculosExclusionEntity[];
    otrosEntity: OtrosExclusionEntity;
    cabvehiculos: CabeceraVehiculosExclusionEntity;
    usuario: ClienteLogin;
    public showLoader: string;
    opcion: number;
    @Input() polizaContratada: PolizaEntity;
    marcas: EspecificacionVehiculoEntity[];
    modelos: EspecificacionVehiculoEntity[];
    versiones: EspecificacionVehiculoEntity[];
    extrasList: EspecificacionVehiculoEntity[];
    @ViewChild('incluirExtra')
    modal: ModalComponent;
    extrasNuevos: ExtrasEntity[];
    extraNuevoModal: ExtrasEntity;
    public uploader: FileUploader;
    public uploaderOtros: FileUploader;
    private url = "solicitudes";
    vehiculoNuevo: DetalleVehiculoEntity;
    devolverMensaje: any;
    inspeccion: DatosInspeccionEntity;
    factura: DatosFacturaEntity;
    es: any;
    //vehiculosChk: any[];
    vehiculosChk: any = {};
    //items: any[];
    //items=[{name:'uno',chosen:false},{name:'dos',chosen:false}];
    dateS: Date;
    dateSh: Date;
    fechavigencia:string;
    fechavigenciah:string;
    filterQuery: string;

    constructor(

        private exclusionVehiculosService: ExclusionVehiculosService,
        public utilsService: UtilService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService) {
        super();
        this.otrosEntity = new OtrosExclusionEntity();
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;


        this.uploader = new FileUploader({
            url: this.url + '/solicitarInclusionVehiculo',
            allowedMimeType: ['image/jpeg',
                'image/png',
                'application/pdf',
                'application/msword',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/x-zip-compressed'
            ],
            maxFileSize: 5 * 1024 * 1024, /*limitado a 5 MB*/
            removeAfterUpload: true
        });

        this.uploader.options.headers = [];

        this.uploader.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };


        this.uploader.onCompleteItem = (item: any, response: any, status: number, headers: any) => {
            this.devolverMensaje(status, 1);
        }

        this.uploaderOtros = new FileUploader({
            url: this.url + '/otrosMov',
            allowedMimeType: ['image/jpeg',
                'image/png',
                'application/pdf',
                'application/msword',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/x-zip-compressed'
            ],
            maxFileSize: 5 * 1024 * 1024, /*limitado a 5 MB*/
            removeAfterUpload: true
        });

        this.uploaderOtros.options.headers = [];

        this.uploaderOtros.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };

        this.uploaderOtros.onCompleteItem = (item: any, response: any, status: number, headers: any) => {
            this.devolverMensaje(status, 2);
        }

        this.devolverMensaje = (parametro: number, tipoSolicitud: number): void => {

            let textoSolicitud = "";

            if (tipoSolicitud == 1)
                textoSolicitud = "inclusión";
            else
                textoSolicitud = "otros movimientos";


            if (parametro == 200) {
                swal({
                    title: 'Solicitud de ' + textoSolicitud + ' de bien asegurado',
                    text: 'Su solicitud ha sido enviada exitosamente. En breve, un ejecutivo procesará su solicitud.',
                    type: 'success',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                }).then(function () {
                    window.location.reload(true);
                });
            }
            else {
                swal({
                    title: 'Error en solicitud de ' + textoSolicitud,
                    text: 'No se pudo realizar el envío de la solicitud de ' + textoSolicitud + ', por favor vuelva a intentar. En caso de volver a presentarse el mismo mensaje repórtelo a su ejecutivo de cuenta.',
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            }

        }
    }
    ngOnInit(): void {
       // console.log(this.usuario.CodigoUsuario);
       this.vehiculos = [];
        this.es = {
            firstDayOfWeek: 1,
            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
            monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
            monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
        }
    }
    noSeleccionado() {
        //[disabled]="!noSeleccionado()"
        //return !this.items.some(item=>item.chosen);
        //return !this.vehiculosChk.some(veh => veh.CodigoVehiculo);
    }
    excluirVehiculo(veh: VehiculosExclusionEntity) {
        this.vehiculosChk[veh.CodigoVehiculo];
        console.log(veh);
    }
    excluirVehiculosSeleccionados() {

        let cabVehiculo = new CabeceraVehiculosExclusionEntity();

        Object.keys(this.vehiculosChk).forEach((item, index) => {
            if (this.vehiculosChk[item]) {
                (this.vehiculos).forEach(x => {
                    if (x.CodigoVehiculo.toString() == item) {
                        x.EstadoSolicitud = 1;
                    }
                });
            }
        }
        );

        cabVehiculo.CodigoAseguradora = this.polizaContratada.CodigoAseguradora;
        cabVehiculo.CodigoCiudad = this.polizaContratada.CodigoCiudad;
        cabVehiculo.CodigoCliente = this.polizaContratada.CodigoCliente;
        cabVehiculo.CodigoPoliza = this.polizaContratada.CodigoPoliza;
        cabVehiculo.CodigoRamo = this.polizaContratada.CodigoRamo;
        cabVehiculo.CodigoAseguradora = this.polizaContratada.CodigoAseguradora;
        cabVehiculo.CodigoUnidad = this.polizaContratada.CodigoUnidad;
        cabVehiculo.RolEmpleado = this.polizaContratada.RolEmpleado;
        cabVehiculo.CodigoUsuario = this.usuario.CodigoUsuario;
        cabVehiculo.VehiculosExclusion = (this.vehiculos).filter(v => v.EstadoSolicitud == 1);

        this.exclusionVehiculosService.excluirVehiculos(cabVehiculo).subscribe(
            result => {
                if (result) {
                    swal({
                        title: 'Exclusión',
                        text: "Ha solicitado la exclusión de los vehículos seleccionados, pronto se comunicará con ud. su ejecutivo para completar el proceso",
                        type: 'success'
                    }).then(function () {
                        window.location.reload(true);
                    });
                } else {
                    swal({
                        title: 'Exclusión',
                        text: "A ocurrido un inconveniente al intentar enviar su solicitud",
                        type: 'warning'
                    }).then(function () {
                        this.router.navigate(["/error/500"]);
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); }
        );
    }

    ngOnChanges() {
        this.showLoader = "sk-loading";
        this.otrosEntity.CodigoCiudad = this.polizaContratada.CodigoCiudad;
        this.otrosEntity.CodigoCliente = this.polizaContratada.CodigoCliente;
        this.otrosEntity.CodigoPoliza = this.polizaContratada.CodigoPoliza;
        this.otrosEntity.RolEmpleado = this.polizaContratada.RolEmpleado;
        this.otrosEntity.CodigoRamo = this.polizaContratada.CodigoRamo;
        this.otrosEntity.CodigoAseguradora = this.polizaContratada.CodigoAseguradora;
        this.inspeccion = new DatosInspeccionEntity();
        this.factura = new DatosFacturaEntity();

        correctHeight();
        detectBody();
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                let a = 1;
                this.exclusionVehiculosService.consultaVehiculos(this.polizaContratada).subscribe(
                    datosVehiculos => {
                        this.cabvehiculos = datosVehiculos;
                        this.vehiculos = this.cabvehiculos.VehiculosExclusion;
                        console.log(this.vehiculos);
                    },
                    error => { this.handleError.redirectUrl(error); });

                this.utilsService.getMarcas().subscribe(
                    marcas => { this.marcas = marcas; },
                    error => { this.handleError.redirectUrl(error); }
                );
                this.utilsService.getExtras().subscribe(
                    extras => this.extrasList = extras,
                    error => { this.handleError.redirectUrl(error); }
                );
                this.extraNuevoModal = new ExtrasEntity();
                this.extrasNuevos = new Array<ExtrasEntity>();
                this.vehiculoNuevo = new DetalleVehiculoEntity();
                this.vehiculoNuevo.ValorExtras = 0;
                this.vehiculoNuevo.Deducible = false;
                this.factura.FacturaOtraPersona = false;
                this.vehiculoNuevo.CodigoUsuarioExtranet = this.usuario.CodigoUsuario;

            }
        }
    }
    cargaModelos(marcaCod) {
        if (marcaCod != "") {
            this.versiones = null;
            this.modelos = null;
            this.utilsService.getModelos(marcaCod).subscribe(
                modelos => { this.modelos = modelos; },
                error => { this.handleError.redirectUrl(error); }
            );
        }
    }

    cargaVersiones(modeloCod) {
        if (modeloCod != "") {
            this.utilsService.getVersiones(modeloCod).subscribe(
                versiones => { this.versiones = versiones; },
                error => { this.handleError.redirectUrl(error); }
            );
        }
    }

    modalClose() {
        this.modal.close();
        this.extraNuevoModal = new ExtrasEntity();
    }


    eliminarExtraNuevo(extra) {
        this.extrasNuevos = this.extrasNuevos.filter(function (el) { return el.CodExtra !== extra.CodExtra; });
    }

    editarExtraNuevo(extra) {
        this.extraNuevoModal = this.cloneExtra(extra);
        this.modal.open();
    }
    cloneExtra(c: ExtrasEntity) {
        let extra = new ExtrasEntity();
        for (let prop in c) {
            extra[prop] = c[prop];
        }
        return extra;
    }
    incluirExtraNuevo() {

        let codigo = this.extraNuevoModal;
        let valor = this.extrasList.find(function (el) {
            return el.Id == codigo.NombreExtraCod;
        });
        if (this.extraNuevoModal.CodExtra == undefined) {
            let date = new Date();
            this.extraNuevoModal.NombreExtra = valor.Descripcion;
            this.extraNuevoModal.CodExtra = date.getMilliseconds() + date.getFullYear();
            this.extrasNuevos.push(this.extraNuevoModal);
        } else {
            this.extrasNuevos.forEach(function (e1) {
                if (e1.CodExtra == codigo.CodExtra) {

                    e1.Marca = codigo.Marca;
                    e1.Modelo = codigo.Modelo;
                    e1.NombreExtra = valor.Descripcion;
                    e1.ValorExtra = codigo.ValorExtra;
                    e1.NombreExtraCod = codigo.NombreExtraCod;
                }
            });
        }
        this.vehiculoNuevo.ValorExtras = 0;
        this.extrasNuevos.forEach(a => {
            this.vehiculoNuevo.ValorExtras += a.ValorExtra * 1;
        });
        this.modal.close();
        this.extraNuevoModal = new ExtrasEntity();
    }

    uploadFilesInQueue(tipoSolicitud: number): void {

         let fechaSin =  this.dateS;
         let fechaSinh =  this.dateSh;
        if(fechaSin!=undefined ){//|| fechaSinh!=undefined){
        let dateString = fechaSin.getDate()+"/"+ (Number(fechaSin.getMonth())+1)+"/"+fechaSin.getFullYear()
       // let dateStringh = fechaSinh.getDate()+"/"+ fechaSinh.getMonth()+"/"+fechaSinh.getFullYear()
        this.fechavigencia=dateString;
        //this.fechavigenciah=dateStringh;
        }
        else{
            this.fechavigencia="";
          //  this.fechavigenciah="";
        }
        
        if (tipoSolicitud == 1) //inclusión
        {

            if (this.uploader.getNotUploadedItems().length == 1) {
                this.uploader.options.headers.push(
                    { name: 'Authorization', value: 'Token ' + this.sesionStorageService.retrieve("Token") },
                    { name: 'CodigoPoliza', value: this.polizaContratada.CodigoPoliza + "" },
                    { name: 'CodigoCiudad', value: this.polizaContratada.CodigoCiudad + "" },
                    { name: 'CodigoCliente', value: this.polizaContratada.CodigoCliente + "" },
                    { name: 'CodigoMarca', value: this.vehiculoNuevo.CodMarcaVeh + "" },
                    { name: 'CodigoModelo', value: this.vehiculoNuevo.CodModeloVeh + "" },
                    { name: 'CodigoVersion', value: this.vehiculoNuevo.CodVersionVeh + "" },
                    { name: 'Motor', value: this.vehiculoNuevo.Motor + "" },
                    { name: 'Chasis', value: this.vehiculoNuevo.Chasis + "" },
                    { name: 'Placa', value: this.vehiculoNuevo.Placa + "" },
                    { name: 'Color', value: this.vehiculoNuevo.Color + "" },
                    { name: 'Propietario', value: this.vehiculoNuevo.Propietario + "" },
                    { name: 'CIPropietario', value: this.vehiculoNuevo.CIPropietario + "" },
                    { name: 'ValorAsegurado', value: this.vehiculoNuevo.ValorCasco + "" },
                    { name: 'Deducible', value: this.vehiculoNuevo.Deducible + "" },
                    { name: 'ValorExtras', value: this.vehiculoNuevo.ValorExtras + "" },
                    { name: 'Extras', value: JSON.stringify(this.extrasNuevos) + "" },
                    { name: 'NombreInsp', value: this.inspeccion.Nombres + "" },
                    { name: 'TelefonoInsp', value: this.inspeccion.Telefono + "" },
                    { name: 'FacEmpresa', value: this.factura.FacturaOtraPersona + "" },
                    { name: 'NombreFac', value: this.factura.NombreFac + "" },
                    { name: 'IdentFac', value: this.factura.IdentificacionFac + "" },
                    { name: 'TelefonoFac', value: this.factura.Telefono + "" },
                    { name: 'EmailFac', value: this.factura.EmailFac + "" },
                    { name: 'CodigoUsuarioExtranet', value: this.vehiculoNuevo.CodigoUsuarioExtranet + "" },
                    { name: 'FechaVigencia', value: this.fechavigencia + "" },
                    { name: 'FechaVigenciah', value: this.fechavigenciah + "" },
                    { name: 'Comentarios', value: this.factura.Comentarios + "" }

                );

                this.uploader.uploadItem(this.uploader.getNotUploadedItems()[0]);
            } else if (this.uploader.queue.length > 1) {
                this.uploadAllFiles(tipoSolicitud);
                this.uploader.clearQueue();
            }
        }
        else { //otros mov
            if (this.uploaderOtros.getNotUploadedItems().length == 1) {

                this.uploaderOtros.options.headers.push(
                    { name: 'Authorization', value: 'Token ' + this.sesionStorageService.retrieve("Token") },
                    { name: 'CodigoUsuario', value: this.usuario.CodigoUsuario + "" },
                    { name: 'CodigoCiudad', value: this.otrosEntity.CodigoCiudad + "" },
                    { name: 'CodigoCliente', value: this.otrosEntity.CodigoCliente + "" },
                    { name: 'CodigoPoliza', value: this.otrosEntity.CodigoPoliza + "" },
                    { name: 'RolEmpleado', value: this.otrosEntity.RolEmpleado + "" },
                    { name: 'CodigoRamo', value: this.otrosEntity.CodigoRamo + "" },
                    { name: 'CodigoAseguradora', value: this.otrosEntity.CodigoAseguradora + "" },
                    { name: 'BienAsegurado', value: this.otrosEntity.BienAsegurado + "" },
                    { name: 'Observaciones', value: this.otrosEntity.Observaciones + "" }
                );

                this.uploaderOtros.uploadItem(this.uploaderOtros.getNotUploadedItems()[0]);
            } else if (this.uploaderOtros.queue.length > 1) {
                this.uploadAllFiles(tipoSolicitud);
                this.uploaderOtros.clearQueue();
            }
        }
    }
    uploadAllFiles(tipoSolicitud: number): void {
        const xhr = new XMLHttpRequest();
        const form = new FormData();
        if (tipoSolicitud == 1) //inclusión
        {
            for (const fileItem of this.uploader.getNotUploadedItems()) {
                form.append(fileItem.file.name, fileItem._file, fileItem.file.name);
            }

            xhr.onreadystatechange = (function () {
                if (xhr.readyState === 4) {
                    this.devolverMensaje(xhr.status);
                }
            }).bind(this);
            xhr.open("post", this.url + '/solicitarInclusionVehiculo', true);
            xhr.setRequestHeader("enctype", "multipart/form-data");
            // IE workaround for Cache issues
            xhr.setRequestHeader("Cache-Control", "no-cache");
            xhr.setRequestHeader("Cache-Control", "no-store");
            xhr.setRequestHeader("Pragma", "no-cache");
            xhr.setRequestHeader("Authorization", "Token " + this.sesionStorageService.retrieve("Token"));
            xhr.setRequestHeader("CodigoPoliza", this.polizaContratada.CodigoPoliza + "");
            xhr.setRequestHeader("CodigoCiudad", this.polizaContratada.CodigoCiudad + "");
            xhr.setRequestHeader("CodigoCliente", this.polizaContratada.CodigoCliente + "");
            xhr.setRequestHeader("CodigoMarca", this.vehiculoNuevo.CodMarcaVeh + "");
            xhr.setRequestHeader("CodigoModelo", this.vehiculoNuevo.CodModeloVeh + "");
            xhr.setRequestHeader("CodigoVersion", this.vehiculoNuevo.CodVersionVeh + "");
            xhr.setRequestHeader("Motor", this.vehiculoNuevo.Motor + "");
            xhr.setRequestHeader("Chasis", this.vehiculoNuevo.Chasis + "");
            xhr.setRequestHeader("Placa", this.vehiculoNuevo.Placa + "");
            xhr.setRequestHeader("Color", this.vehiculoNuevo.Color + "");
            xhr.setRequestHeader("Propietario", this.vehiculoNuevo.Propietario + "");
            xhr.setRequestHeader("CIPropietario", this.vehiculoNuevo.CIPropietario + "");
            xhr.setRequestHeader("ValorAsegurado", this.vehiculoNuevo.ValorCasco + "");
            xhr.setRequestHeader("Deducible", this.vehiculoNuevo.Deducible + "");
            xhr.setRequestHeader("ValorExtras", this.vehiculoNuevo.ValorExtras + "");
            xhr.setRequestHeader("Extras", JSON.stringify(this.extrasNuevos) + "");
            xhr.setRequestHeader("NombreInsp", this.inspeccion.Nombres + "");
            xhr.setRequestHeader("TelefonoInsp", this.inspeccion.Telefono + "");
            xhr.setRequestHeader("FacEmpresa", this.factura.FacturaOtraPersona + "");
            xhr.setRequestHeader("NombreFac", this.factura.NombreFac + "");
            xhr.setRequestHeader("IdentFac", this.factura.IdentificacionFac + "");
            xhr.setRequestHeader("TelefonoFac", this.factura.Telefono + "");
            xhr.setRequestHeader("EmailFac", this.factura.EmailFac + "");
            xhr.setRequestHeader("CodigoUsuarioExtranet", this.vehiculoNuevo.CodigoUsuarioExtranet + "");
            xhr.setRequestHeader("FechaVigencia", this.fechavigencia + "");
            xhr.setRequestHeader("FechaVigenciah", this.fechavigenciah + "");
            xhr.setRequestHeader("Comentarios", this.factura.Comentarios + "");
            xhr.send(form);
            console.log("CodigoUsuarioExtranet" + this.vehiculoNuevo.CodigoUsuarioExtranet);
        }
        else //otros movimientos
        {
            for (const fileItem of this.uploaderOtros.getNotUploadedItems()) {
                form.append(fileItem.file.name, fileItem._file, fileItem.file.name);
            }

            xhr.onreadystatechange = (function () {
                if (xhr.readyState === 4) {
                    this.devolverMensaje(xhr.status, 2);
                }
            }).bind(this);
            xhr.open("post", this.url + '/otrosMov', true);
            xhr.setRequestHeader("enctype", "multipart/form-data");
            // IE workaround for Cache issues
            xhr.setRequestHeader("Cache-Control", "no-cache");
            xhr.setRequestHeader("Cache-Control", "no-store");
            xhr.setRequestHeader("Pragma", "no-cache");
            xhr.setRequestHeader("Authorization", "Token " + this.sesionStorageService.retrieve("Token"));
            xhr.setRequestHeader("CodigoUsuario", this.usuario.CodigoUsuario + "");
            xhr.setRequestHeader("CodigoCiudad", this.otrosEntity.CodigoCiudad + "");
            xhr.setRequestHeader("CodigoCliente", this.otrosEntity.CodigoCliente + "");
            xhr.setRequestHeader("CodigoPoliza", this.otrosEntity.CodigoPoliza + "");
            xhr.setRequestHeader("RolEmpleado", this.otrosEntity.RolEmpleado + "");
            xhr.setRequestHeader("CodigoRamo", this.otrosEntity.CodigoRamo + "");
            xhr.setRequestHeader("CodigoAseguradora", this.otrosEntity.CodigoAseguradora + "");
            xhr.setRequestHeader("BienAsegurado", this.otrosEntity.BienAsegurado + "");
            xhr.setRequestHeader("Observaciones", this.otrosEntity.Observaciones + "");
            xhr.send(form);
        }


    };



}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/solicitudes/solicitud-vehiculos.component.ts